import { createContext } from 'react';

import { MovieModal } from '../lib/movieModal';

export const MovieModalContext = createContext<MovieModal | null>(null);
